export { useToast } from "primevue";
import { default as PVAccordion } from "primevue/accordion";
import { default as PVAccordionContent } from "primevue/accordioncontent";
import { default as PVAccordionHeader } from "primevue/accordionheader";
import { default as PVAccordionPanel } from "primevue/accordionpanel";
import { default as PVAutoComplete } from "primevue/autocomplete";
import { default as PVBadge } from "primevue/badge";
import { default as PVBlockUI } from "primevue/blockui";
import { default as PVButton } from "primevue/button";
import { default as PVCard } from "primevue/card";
import { default as PVCheckbox } from "primevue/checkbox";
import { default as PVColumn } from "primevue/column";
import { default as PVDataTable } from "primevue/datatable";
import { default as PVDataView } from "primevue/dataview";
import { default as PVDatePicker } from "primevue/datepicker";
import { default as PVDialog } from "primevue/dialog";
import { default as PVDivider } from "primevue/divider";
import { default as PVDrawer } from "primevue/drawer";
import { default as PVFieldset } from "primevue/fieldset";
import { default as PVFloatLabel } from "primevue/floatlabel";
import { default as PVIconField } from "primevue/iconfield";
import { default as PVImage } from "primevue/image";
import { default as PVInputIcon } from "primevue/inputicon";
import { default as PVInputNumber } from "primevue/inputnumber";
import { default as PVInputOTP } from "primevue/inputotp";
import { default as PVInputText } from "primevue/inputtext";
import { default as PVMessage } from "primevue/message";
import { default as PVMultiSelect } from "primevue/multiselect";
import { default as PVOverlayBadge } from "primevue/overlaybadge";
import { default as PVPanel } from "primevue/panel";
import { default as PVPanelMenu } from "primevue/panelmenu";
import { default as PVPassword } from "primevue/password";
import { default as PVPopover } from "primevue/popover";
import { default as PVProgressBar } from "primevue/progressbar";
import { default as PVProgressSpinner } from "primevue/progressspinner";
import { default as PVRadioButton } from "primevue/radiobutton";
import { default as PVRating } from "primevue/rating";
import { default as PVSelect } from "primevue/select";
import { default as PVSkeleton } from "primevue/skeleton";
import { default as PVSplitButton } from "primevue/splitbutton";
import { default as PVStep } from "primevue/step";
import { default as PVStepList } from "primevue/steplist";
import { default as PVStepPanel } from "primevue/steppanel";
import { default as PVStepPanels } from "primevue/steppanels";
import { default as PVStepper } from "primevue/stepper";
import { default as PVTab } from "primevue/tab";
import { default as PVTabList } from "primevue/tablist";
import { default as PVTabPanel } from "primevue/tabpanel";
import { default as PVTabPanels } from "primevue/tabpanels";
import { default as PVTabs } from "primevue/tabs";
import { default as PVTag } from "primevue/tag";
import { default as PVTextarea } from "primevue/textarea";
import { default as PVToast } from "primevue/toast";
import { default as PVToggleSwitch } from "primevue/toggleswitch";
import { default as PVToolbar } from "primevue/toolbar";

export const PV = {
    Accordion: PVAccordion,
    AccordionContent: PVAccordionContent,
    AccordionHeader: PVAccordionHeader,
    AccordionPanel: PVAccordionPanel,
    AutoComplete: PVAutoComplete,
    Badge: PVBadge,
    BlockUI: PVBlockUI,
    Button: PVButton,
    Card: PVCard,
    Checkbox: PVCheckbox,
    Column: PVColumn,
    DataTable: PVDataTable,
    DataView: PVDataView,
    DatePicker: PVDatePicker,
    Dialog: PVDialog,
    Divider: PVDivider,
    Drawer: PVDrawer,
    Fieldset: PVFieldset,
    FloatLabel: PVFloatLabel,
    IconField: PVIconField,
    Image: PVImage,
    InputIcon: PVInputIcon,
    InputNumber: PVInputNumber,
    InputOTP: PVInputOTP,
    InputText: PVInputText,
    Message: PVMessage,
    MultiSelect: PVMultiSelect,
    OverlayBadge: PVOverlayBadge,
    Panel: PVPanel,
    PanelMenu: PVPanelMenu,
    Password: PVPassword,
    Popover: PVPopover,
    ProgressBar: PVProgressBar,
    ProgressSpinner: PVProgressSpinner,
    RadioButton: PVRadioButton,
    Rating: PVRating,
    Select: PVSelect,
    Skeleton: PVSkeleton,
    SplitButton: PVSplitButton,
    Step: PVStep,
    StepList: PVStepList,
    StepPanel: PVStepPanel,
    StepPanels: PVStepPanels,
    Stepper: PVStepper,
    Tab: PVTab,
    TabList: PVTabList,
    TabPanel: PVTabPanel,
    TabPanels: PVTabPanels,
    Tabs: PVTabs,
    Tag: PVTag,
    Textarea: PVTextarea,
    Toast: PVToast,
    ToggleSwitch: PVToggleSwitch,
    Toolbar: PVToolbar,
};

import { RouterLink, RouterView } from "vue-router";

export const VR = {
    RouterLink: RouterLink,
    RouterView: RouterView,
};
